import queryString from 'query-string';

export default function getSearchParams(search) {
  if (search && search.length) {
    return queryString.parse(search.slice(1));
  }

  return {};
}
